<template>
  <div>
    <MyTransition :myName="'up'">
      <Popup v-if="popupStatus">
        <PopupCheck v-if="popup == 'check'" :text="successText" @go="popupAction" @cancel="poupupEnter">
        </PopupCheck>
        <PopupSuccess v-if="popup == 'success'" :text="successText" @check="poupupEnter"></PopupSuccess>
        <PopupError v-if="popup == 'error'" :text="successText" @check="poupupEnter"></PopupError>
      </Popup>
    </MyTransition>
    <div class="search_block" v-if="$route.path === '/admin/new_construction'">
      <Search :filed="searchField" :searchAction="searchAction" :searchStatus="searchStatus"></Search>
    </div>
    <div class="costruction table_outter_block" style="height: calc(100vh - 100px)">
      <div class="update_btn flex flex_end" v-if="!$route.path.includes('new_construction_finished')">
        <button class="btn_warning" @click="updateUOF">
          <i class="el-icon-refresh-left"></i>更新UOF狀態
        </button>
      </div>
      <Loading part></Loading>
      <div v-if="tableData.length !== 0">
        <PersonalTable>
          <TableThead :thead="clearThead" :thead_scroll="thead_scroll" slot="thead" @tableSort="tableSort"
            @eventGetHeight="eventGetHeight"></TableThead>
          <div class="personal_data_table" slot="tbody" :style="`top:${table_head_heigh}px;  height:calc(100vh - ${330 - table_head_heigh
      }px);`" @scroll="scrollEvent">
            <table>
              <colgroup>
                <col v-for="(th, index) in clearThead" :key="index" :width="th.width" />
              </colgroup>
              <tbody>
                <template v-for="(data, index) in pageData">
                  <!--外層table content-->
                  <tr :class="finishCase(data)" :key="`application_${index}`">
                    <template v-for="(th, th_index) in clearThead">
                      <!--展開每日施工單-->
                      <!-- <td
                                                :class="
                                                    th.align == 'center'
                                                        ? 'text_center'
                                                        : false
                                                "
                                                :key="`info_${th_index}`"
                                                v-if="th.value == 'form_id'"
                                            >
                                                <div
                                                    class="info_icon"
                                                    @click="
                                                        openWork(data, index)
                                                    "
                                                >
                                                    <i class="el-icon-more"></i>
                                                </div>
                                            </td> -->
                      <td :class="th.align == 'center'
      ? 'text_center'
      : false
      " :key="`info_${th_index}`" v-if="th.value == 'info'">
                        <!-- <div
                                                    class="info_icon"
                                                    @click="
                                                        openWork(data, index)
                                                    "
                                                >
                                                    <i class="el-icon-more"></i>
                                                </div> -->
                        <el-button class="info_icon" type="text" @click="
      openWork(data, index)
      "><i class="el-icon-more"></i></el-button>
                      </td>
                      <!--承攬商--->
                      <td :class="th.align == 'center'
      ? 'text_center'
      : false
      " :key="`vendor_chinese_${th_index}`" v-else-if="th.value ==
      'vendors.vendor_chinese'
      ">
                        <!--key: th.value.split("_")[0],-->
                        <!-- 原來的{{
                                                    labelTransform({
                                                        key: th.value.split(
                                                            "_"
                                                        )[0],
                                                        data: data[th.value],
                                                        inner_key: [
                                                            "vendor_chinese",
                                                        ],
                                                    })
                                                }} -->

                        <p v-for="item in data.vendors" :key="item.vendor_chinese">
                          {{ item.vendor_chinese }}
                        </p>
                      </td>
                      <!-- 連結 -->
                      <td :class="th.align == 'center'
      ? 'text_center'
      : false
      " class="uof_link" @click="openOrder(data)" :key="`uof_${th_index}`" v-else-if="th.value == 'link'">
                        <button class="icon_btn btn_primary">
                          <i class="el-icon-link"></i>
                        </button>
                      </td>

                      <!--是否結案-->
                      <td :class="th.align == 'center'
      ? 'text_center'
      : false
      " :key="`state_${th_index}`" v-else-if="th.value == 'status'">
                        <template v-if="data.status == '同意'">
                          <p class="blue">
                            <i class="el-icon-success"></i>
                          </p>
                        </template>
                        <template v-else><i class="el-icon-error"></i></template>
                      </td>

                      <!--陣列-->
                      <td class="table_array" :class="th.align == 'center'
      ? 'text_center'
      : false
      " :key="`array_${th_index}`" v-else-if="data[th.value] &&
      Array.isArray(
        data[th.value]
      )
      ">
                        <p v-for="item in data[
      th.value
      ]" :key="item">
                          {{
      labelTransform({
        key: th.value.split(
          "_"
        )[0],
        data: item,
        inner_key: [
          "id",
          "vendor_id",
        ],
      })
    }}
                        </p>
                      </td>
                      <!--兩層object key-->
                      <td v-else-if="th.value.includes('.')
      " :key="`object_${th_index}`">
                        {{
      transfromData(
        data,
        th.value
      )
    }}
                      </td>

                      <!--default-->
                      <td :class="th.align == 'center'
        ? 'text_center'
        : false
      " :key="`data_${th_index}`" v-else>
                        {{ data[th.value] }}
                      </td>
                    </template>
                  </tr>
                  <!---展開第二層-->

                  <el-dialog top="7vh" @close="openWork(data, index)" :show-close="false" :visible.sync="check_inner_status[index].status
      ">
                    <tr class="table_second" :key="`daliy_${index}`" v-if="check_inner_status[index]
      .status == true &&
      check_inner_status[index]
        .status_index == index
      ">
                      <td>
                        <div class="table_second__innerbox">
                          <div class="item" :class="inner_thead.dependent
      ? false
      : 'independent'
      " v-for="(
                                                            inner_thead,
      inner_thead_index
                                                        ) in clearInnerThead" :key="inner_thead_index">
                            <div class="name">
                              {{
      inner_thead.name
    }}
                            </div>
                            <!--申請日期-->
                            <!-- <template
                                                            v-if="
                                                                inner_thead.value ==
                                                                'commit'
                                                            "
                                                        >
                                                            {{
                                                                labelTransform({
                                                                    key: "commit",
                                                                    data: data,
                                                                    inner_key: [
                                                                        "created_at",
                                                                    ],
                                                                })
                                                            }}
                                                        </template> -->
                            <!-- UOF連結 -->
                            <template v-if="inner_thead.value ==
      'link'
      ">
                              <button class="btn_border" @click="
      openOrder(
        data
      )
      ">
                                <i class="el-icon-link"></i>
                              </button>
                            </template>
                            <!--承辦人員-->
                            <template v-else-if="inner_thead.value ==
      'employee'
      ">
                              <!-- {{
                                                                labelTransform({
                                                                    key: inner_thead.value,
                                                                    data: data,
                                                                    inner_key: [
                                                                        "name",
                                                                    ],
                                                                })
                                                            }} -->
                              {{
      data.employee
        .name
    }}
                            </template>
                            <!--作業區域-->
                            <template v-else-if="inner_thead.value ==
      'area'
      ">
                              <p v-for="area in transfromData(
      data,
      inner_thead.value
    )">
                                <i class="el-icon-caret-right"></i>
                                {{ area }}
                              </p>
                            </template>

                            <!--承攬商監工-->
                            <template v-else-if="inner_thead.value ==
      'vendors'
      ">
                              <p class="inner_name" v-for="(
                                                                    item, index
                                                                ) in data.vendors" :key="`vendor_${index}`">
                                {{
      item.vendor_chinese
    }}
                                /
                                {{
        item
          .supervisor
          .name
      }}
                                <!-- {{
                                                                    item.vendor_chinese / item
                                                                        .supervisor
                                                                        .name
                                                                }} -->
                              </p>
                            </template>
                            <!--施工人員: -->
                            <template v-else-if="inner_thead.value ==
      'visitors'
      ">
                              <p v-for="item in data[
      inner_thead
        .value
    ]" :key="item.name">
                                {{ item.name }}
                              </p>
                            </template>
                            <!--文件操作-->
                            <template v-else-if="inner_thead.value ==
      'files'
      ">
                              <div class="item" v-if="data.status ==
      '同意'
      ">
                                <!-- 如果要列印施工單, 要另外做一份新的樣式for new_work -->
                                <!-- <button
                                                                    class="btn_border"
                                                                    @click="
                                                                        print(
                                                                            data
                                                                        )
                                                                    "
                                                                >
                                                                    列印施工單
                                                                </button> -->
                              </div>
                              <!--協議組織規範事項-->
                              <div v-if="Object.keys(
      data.commit
    ).length !=
      0
      " class="item flex flex_align_center">
                                <div class="inner_name">
                                  協議組織規範事項
                                </div>

                                <button class="icon_btn btn_border" v-if="Object.keys(
      data.commit
    )
      .length !==
      0
      " @click="
      defaultRouter(
        'new_commit',
        {
          work_id:
            data
              .commit
              .id,
          new_work_id:
            data
              .commit
              .new_work_id,
        }
      )
      ">
                                  <i class="el-icon-document"></i>
                                </button>
                                <div v-else>
                                  -
                                </div>
                              </div>
                              <div v-else>--</div>
                              <!-- <div
                                                                class="item flex"
                                                            >
                                                                <div
                                                                    class="inner_name"
                                                                >
                                                                    每日工具箱會議及危害告知紀錄
                                                                </div>
                                                                <button
                                                                    class="icon_btn btn_border"
                                                                    v-if="
                                                                        Object.keys(
                                                                            data.toolbox
                                                                        )
                                                                            .length !==
                                                                        0
                                                                    "
                                                                    @click="
                                                                        defaultRouter(
                                                                            'toolbox',
                                                                            {
                                                                                work_id:
                                                                                    data
                                                                                        .toolbox
                                                                                        .id,
                                                                            }
                                                                        )
                                                                    "
                                                                >
                                                                    <i
                                                                        class="el-icon-document"
                                                                    ></i>
                                                                </button>
                                                                <div v-else>
                                                                    -
                                                                </div>
                                                            </div> -->
                              <div class="item upload_box" v-if="is_role ==
      'manager'
      ">
                                <input type="file" :id="`${index}_${inner_thead_index}`" multiple @change="
      upload(
        $event,
        `${index}_${inner_thead_index}`,
        data.id
      )
      " />
                                <label :for="`${index}_${inner_thead_index}`" class="upload_UI_finish"><i
                                    class="el-icon-upload2"></i>上傳備註文件</label>
                              </div>
                              <template v-if="is_role ==
      'manager'
      ">
                                <div class="item attachment flex" v-for="(
                                                                        f,
      f_index
                                                                    ) in data[
      'attachment'
    ]" :key="f_index
      ">
                                  <div class="inner_name">
                                    {{
      f.filename
    }}
                                  </div>
                                  <button class="icon_btn btn_border" @click="
    link(
      `${f.path}`
    )
      ">
                                    <i class="el-icon-document"></i>
                                  </button>
                                  <button class="icon_btn btn_error" @click="
      deleteFile(
        data.id,
        f.id
      )
      ">
                                    <i class="el-icon-delete-solid"></i>
                                  </button>
                                </div>
                              </template>
                            </template>
                            <!--施工單明細-->
                            <template v-else-if="inner_thead.value ==
      'dailys'
      ">
                              <div class="flex">
                                <div class="the_day_list">
                                  <div class="flex list_item flex_align_center" v-for="(
                                                                            the_day,
      day_index
                                                                        ) in data.dailys" :key="`dailys_${day_index}`">
                                    <div class="the_day">
                                      <span v-if="the_day.is_finished ===
      1
      ">
                                        <i class="el-icon-success">
                                        </i>
                                      </span>
                                      {{
      the_day.date
    }}

                                      <div class="daily_works_finished" v-if="the_day
        .visitors
        .length >
      0
      ">
                                        <!--上傳 每日巡檢表-->
                                        <div class="item upload_box">
                                          <input type="file" :disabled="findUpload_files(
      '每日巡檢表',
      the_day
    )
      " :id="`每日巡檢表_${the_day.date}`" @change="
      uploadFinished(
        $event,
        '每日巡檢表',
        the_day.id
      )
      " />
                                          <label :for="`每日巡檢表_${the_day.date}`" class="upload_UI_finish">
                                            <div v-if="findUpload_files(
      '每日巡檢表',
      the_day
    ) &&
      the_day.daily_check
      ">
                                              <i class="el-icon-check"></i>
                                              每日巡檢表:
                                              <div class="attachment">
                                                <!-- <div
                                                                                                class="inner_name"
                                                                                            >
                                                                                                {{
                                                                                                    the_day
                                                                                                        .daily_check
                                                                                                        .filename
                                                                                                }}
                                                                                            </div> -->

                                                <button class="icon_btn btn_border" @click="
      link(
        `${the_day.daily_check.path}`
      )
      ">
                                                  <i class="el-icon-document"></i>
                                                </button>
                                                <button class="icon_btn btn_error" @click="
      deleteFile(
        the_day.id,
        the_day
          .daily_check
          .id
      )
      ">
                                                  <i class="el-icon-delete-solid"></i>
                                                </button>
                                              </div>
                                            </div>

                                            <div v-else>
                                              <i class="el-icon-upload2"></i>上傳
                                              每日巡檢文件
                                            </div>
                                          </label>
                                        </div>
                                        <!--上傳 危險作業檢查表-->
                                        <div class="item upload_box" v-if="the_day.cancel_op ===
      0 &&
      the_day.op ===
      1
      ">
                                          <input type="file" :disabled="findUpload_files(
      '危險作業檢查表',
      the_day
    )
      " :id="`危險作業檢查表_${the_day.date}`" @change="
      uploadFinished(
        $event,
        '危險作業檢查表',
        the_day.id
      )
      " />
                                          <label :for="`危險作業檢查表_${the_day.date}`" class="upload_UI_finish">
                                            <div v-if="findUpload_files(
      '危險作業檢查表',
      the_day
    ) &&
      the_day.danger_check
      ">
                                              <i class="el-icon-check"></i>
                                              危險作業檢查表:
                                              <div class="attachment">
                                                <!-- <div
                                                                                                class="inner_name"
                                                                                            >
                                                                                                {{
                                                                                                    the_day
                                                                                                        .danger_check
                                                                                                        .filename
                                                                                                }}
                                                                                            </div> -->

                                                <button class="icon_btn btn_border" @click="
      link(
        `${the_day.danger_check.path}`
      )
      ">
                                                  <i class="el-icon-document"></i>
                                                </button>
                                                <button class="icon_btn btn_error" @click="
      deleteFile(
        the_day.id,
        the_day
          .danger_check
          .id
      )
      ">
                                                  <i class="el-icon-delete-solid"></i>
                                                </button>
                                              </div>
                                            </div>

                                            <div v-else>
                                              <i class="el-icon-upload2"></i>上傳
                                              危險作業檢查表
                                            </div>
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="the_day_detail">
                                      <div class="item flex flex_column" :class="daily_inner_thead.dependent
      ? false
      : 'independent'
      " v-for="(
                                                                                    daily_inner_thead,
      daily_inner_thead_index
                                                                                ) in dailyInnerThead" :key="daily_inner_thead_index
      ">
                                        <div class="name">
                                          {{
      daily_inner_thead.name
    }}
                                        </div>
                                        <div>
                                          <!--Toolbox-->

                                          <template v-if="daily_inner_thead.value ==
      'toolbox' &&
      data.status ==
      '同意'
      ">
                                            <div class="item flex flex_align_center">
                                              <div class="inner_name">
                                                每日工具箱會議及危害告知紀錄
                                              </div>

                                              <button class="icon_btn btn_border" v-if="Object.keys(
      data.commit
    )
      .length !==
      0
      " @click="
      defaultRouter(
        'new_toolbox',
        {
          work_id:
            the_day
              .toolbox
              .id,
          new_work_id:
            the_day.new_work_id,
          toolbox_id:
            the_day
              .toolbox
              .daily_id,
        }
      )
      ">
                                                <!-- {
                                                                                                            work_id:
                                                                                                                data
                                                                                                                    .dailys[
                                                                                                                    index
                                                                                                                ].toolbox.id,
                                                                                                            new_work_id:
                                                                                                                data.dailys[index
                                                                                                                ].new_work_id,
                                                                                                            toolbox_id:
                                                                                                                data
                                                                                                                    .dailys[
                                                                                                                    index
                                                                                                                ]
                                                                                                                    .toolbox
                                                                                                                    .daily_id,
                                                                                                        } -->
                                                <i class="el-icon-document"></i>
                                              </button>
                                              <div v-else>
                                                -
                                              </div>
                                            </div>
                                          </template>
                                          <!--施工人員-->
                                          <template v-else-if="daily_inner_thead.value ==
      'visitors' &&
      data.status ==
      '同意'
      ">
                                            <div class="item flex">
                                              <i v-if="the_day
      .visitors
      .length >
      0
      " class="el-icon-success"></i>
                                              <i v-else class="el-icon-error"></i>
                                            </div>
                                          </template>
                                          <!--是否有特殊作業-->
                                          <template v-else-if="daily_inner_thead.value ==
      'op'
      " class="item" :class="
                                                                                            daily_inner_thead.dependent
                                                                                                ? false
                                                                                                : 'independent'
                                                                                        ">
                                            {{
      the_day.op ==
        1
        ? "是"
        : "否"
    }}
                                          </template>
                                          <!--特殊作業清單-->
                                          <template v-else-if="daily_inner_thead.value ==
      'op_id' &&
      the_day.op ==
      1
      " class="item" :class="
                                                                                            daily_inner_thead.dependent
                                                                                                ? false
                                                                                                : 'independent'
                                                                                        ">
                                            <div v-for="(
                                                                                                item,
      index
                                                                                            ) in the_day.op_id"
                                              :key="`op_${index}`">
                                              <i class="el-icon-caret-right"></i>
                                              {{
      item
    }}
                                            </div>
                                          </template>
                                          <!--是否影響fab乾淨度-->
                                          <template v-else-if="daily_inner_thead.value ==
      'clean'
      " class="item" :class="
                                                                                            daily_inner_thead.dependent
                                                                                                ? false
                                                                                                : 'independent'
                                                                                        ">
                                            {{
      the_day.clean ==
        1
        ? "是"
        : "否"
    }}
                                          </template>
                                          <!--影響fab乾淨度的原因-->
                                          <template v-else-if="daily_inner_thead.value ==
      'clean_list' &&
      the_day.clean ==
      1
      " class="item" :class="
                                                                                            daily_inner_thead.dependent
                                                                                                ? false
                                                                                                : 'independent'
                                                                                        ">
                                            <p v-for="item in the_day.clean_list">
                                              <i class="el-icon-caret-right"></i>
                                              {{
      item
    }}
                                            </p>
                                          </template>
                                          <!--是否影響環境-->
                                          <template v-else-if="daily_inner_thead.value ==
      'environment'
      " class="item" :class="
                                                                                            daily_inner_thead.dependent
                                                                                                ? false
                                                                                                : 'independent'
                                                                                        ">
                                            {{
      the_day.environment ==
        1
        ? "是"
        : "否"
    }}
                                          </template>
                                          <!--影響環境清單-->
                                          <template v-else-if="daily_inner_thead.value ==
      'environment_list' &&
      the_day.environment ==
      1
      " class="item" :class="
                                                                                            daily_inner_thead.dependent
                                                                                                ? false
                                                                                                : 'independent'
                                                                                        ">
                                            <p v-for="item in the_day.environment_list">
                                              <i class="el-icon-caret-right"></i>
                                              {{
      item
    }}
                                            </p>
                                          </template>
                                          <!--是否取消特殊作業-->
                                          <template v-else-if="daily_inner_thead.value ==
      'op_cancel' &&
      the_day.op ===
      1
      " class="item" :class="
                                                                                            daily_inner_thead.dependent
                                                                                                ? false
                                                                                                : 'independent'
                                                                                        ">否
                                            <el-switch :disabled="the_day.cancel_op ===
      1
      " :value="the_day.cancel_op
      " :active-value="1
      " :inactive-value="0
      " active-color="#13ce66" inactive-color="#ff4949" @change="
      cancelOP(
        the_day
      )
      ">
                                            </el-switch>
                                            是

                                            <p v-if="the_day.cancel_op ===
      1
      ">
                                              取消:
                                              {{
      $moment().format(
        "YYYY-MM-DD h:mm:ss a"
      )
    }}
                                            </p>
                                          </template>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </template>
                            <!--object-->
                            <template v-else-if="inner_thead.value.includes(
      '.'
    )
      ">
                              {{
                              transfromData(
                              data,
                              inner_thead.value
                              )
                              }}
                            </template>
                            <!--陣列-->
                            <template v-else-if="data[
      inner_thead
        .value
      ] &&
      Array.isArray(
        data[
        inner_thead
          .value
        ]
      )
      ">
                              <p v-for="(
                                                                    item, index
                                                                ) in data[
      inner_thead
        .value
      ]" :key="`innerThead_${item}`">
                                <i class="el-icon-caret-right"></i>
                                {{
                                labelTransform(
                                {
                                key: inner_thead.value.split(
                                "_"
                                )[0],
                                data: item,
                                inner_key:
                                [
                                "id",
                                "op_id",
                                ],
                                }
                                )
                                }}
                              </p>
                            </template>
                            <template v-else>
                              {{
                              data[
                              inner_thead
                              .value
                              ]
                              }}
                            </template>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <!-- <span
                                            slot="footer"
                                            class="dialog-footer"
                                        >
                                            <el-button
                                                @click="dialogVisible = false"
                                                >取 消</el-button
                                            >
                                            <el-button
                                                type="primary"
                                                @click="dialogVisible = false"
                                                >确 定</el-button
                                            >
                                        </span> -->
                  </el-dialog>
                </template>
              </tbody>
            </table>
          </div>
        </PersonalTable>
        <el-pagination :page-size="page.size + 1" :pager-count="11" layout="prev, pager, next" :total="page.allPage"
          @current-change="pageChange"></el-pagination>
      </div>

      <div class="no_data" v-else-if="this.$store.state.loading == false">
        <i class="el-icon-warning-outline"></i>
        <p>NO Data</p>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.costruction {
  .info_icon {
    cursor: pointer;
  }

  .table_array {
    p {
      padding: 5px 10px;
      margin: 5px 0;
      border-radius: 5px;
      background: lighten(#682dff, 35%);
    }
  }

  .finish_over_7days {
    // background-color: #dcddff;
    background-color: #f1f1f19c;
    //box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);
    //border: 2px dashed var(--mainColor2);
  }
}

.table_second {
  &:hover {
    background: #676767 !important;
  }

  background: #676767;
  color: #fff;

  table {
    thead {
      background: transparent;
    }

    tbody {
      >tr {
        &:hover {
          background: #676767 !important;
        }
      }
    }

    .table_array {
      color: #fff;

      p {
        background: transparent;
        border: 1px solid #fff;
      }
    }
  }
}

.text_center {
  text-align: center;
}

.search_block {
  margin-top: 10px;
}

.search {
  cursor: pointer;

  >div {
    align-items: center;
  }
}

.update_btn {
  >button {
    width: 150px;
  }
}

.upload_box {
  width: 90%;

  input {
    display: none;
  }

  .upload_UI_finish {
    margin-top: 10px;
    font-size: 13px;
    border-radius: 5px;
    cursor: pointer;
    border: 1px dashed #ccc;
    display: block;
    text-align: center;
    padding: 10px 30px;
    color: #ccc;

    &:hover {
      border: 1px solid #fff;
      color: #fff;

      i {
        color: #fff;
      }
    }

    .attachment {
      margin: 0 auto;
      margin-top: 8px;

      .inner_name {
        margin-right: 5px;
      }

      button {
        margin-right: 8px;
      }
    }
  }
}

.the_day_list {
  width: 100%;

  .list_item {
    margin-bottom: 12px;
    border-bottom: 2px dotted white;
    justify-content: space-between;

    .the_day {
      font-size: 20px;
      text-align: center;
    }

    .the_day_detail {
      width: 60%;

      .item {
        p {
          margin-top: 3px;
        }
      }
    }
  }

  .el-icon-success {
    font-size: 22px;
    color: var(--green);
  }

  .el-icon-error {
    font-size: 22px;
    color: rgb(242, 90, 90);
  }
}

.el-dialog {
  .el-dialog__header {
    padding: 0px;
  }

  .el-dialog__body {
    padding: 5px;
    width: fit-content;
  }
}
</style>
<script>
import TableThead from "@/components/global/table/components/TableFixHead";
import PersonalTable from "@/components/global/table/PersonalTable.global";
import mixins from "@/components/mixins.js";
import Options from "@/utils/options";
import Search from "@/components/global/Search";
import Action from "@/components/global/Action";
export default {
  name: "new-construction",
  mixins: [mixins],
  //注入App.vue的method: reload
  inject: ["reload"],
  components: {
    PersonalTable,
    TableThead,
    Search,
    Action,
  },
  data() {
    return {
      thead: [
        {
          name: "細節",
          width: "60px",
          value: "info",
          align: "center",
          role: ["manager", "vendor", "department"],
        },
        {
          name: "簽核狀態",
          width: "60px",
          value: "status",
          align: "center",
          role: ["manager", "vendor", "department"],
        },
        {
          name: "承攬商",
          width: "200px",
          value: "vendors.vendor_chinese",
          align: "center",
          role: ["manager", "department"],
        },

        // {
        //   name: "工程名稱",
        //   width: "220px",
        //   value: "application.name",
        //   align: "left",
        //   role: ["manager", "vendor", "department"],
        // },
        {
          name: "工程名稱",
          width: "180px",
          value: "name",
          align: "left",
          role: ["manager", "vendor", "department"],
        },
        {
          name: "施工起始日",
          width: "120px",
          value: "start_date",
          align: "left",
          role: ["manager", "vendor", "department"],
        },
        {
          name: "施工結束日",
          width: "120px",
          value: "end_date",
          align: "left",
          role: ["manager", "vendor", "department"],
        },
      ],
      check_inner_status: [],
      // inner_status: false,
      // inner_status_index: null,
      innerThead: [
        // {
        //     name: "申請日期",
        //     dependent: false,
        //     value: "commit",
        //     align: "center",
        //     role: ["manager", "vendor", "department"],
        // },
        {
          name: "施工單編號",
          dependent: true,
          value: "form_id",
          align: "left",
          role: ["manager", "vendor", "department"],
        },
        {
          name: "施工開始時間",
          dependent: false,
          value: "start_time",
          align: "left",
          role: ["manager", "vendor", "department"],
        },
        {
          name: "施工結束時間",
          dependent: false,
          value: "end_time",
          align: "left",
          role: ["manager", "vendor", "department"],
        },
        {
          name: "UOF表單",
          dependent: false,
          value: "link",
          align: "center",
          role: ["manager", "department"],
        },
        {
          name: "簽核狀況",
          dependent: false,
          value: "status",
          align: "left",
          role: ["manager", "vendor", "department"],
        },
        {
          name: "現在站點",
          dependent: false,
          value: "current_site",
          align: "center",
          role: ["manager", "department"],
        },
        {
          name: "承辦人員",
          dependent: false,
          value: "employee",
          align: "left",
          role: ["manager", "vendor", "department"],
        },
        // {
        //     name: "作業類型",
        //     dependent: false,
        //     value: "type",
        //     align: "left",
        //     role: ["manager", "vendor", "department"],
        // },
        {
          name: "作業區域",
          dependent: false,
          value: "area",
          align: "left",
          role: ["manager", "vendor", "department"],
        },
        // {
        //     name: "特殊施工",
        //     dependent: false,
        //     value: "op_id",
        //     align: "left",
        //     role: ["manager", "vendor", "department"],
        // },
        // {
        //     name: "作業區域",
        //     dependent: false,
        //     value: "new_work.area",
        //     align: "left",
        //     role: ["manager", "vendor", "department"],
        // },
        {
          name: "承攬商監工",
          dependent: false,
          value: "vendors",
          align: "left",
          role: ["manager", "vendor", "department"],
        },

        {
          name: "文件",
          dependent: true,
          value: "files",
          align: "center",
          role: ["manager", "vendor", "department"],
        },

        {
          name: "施工明細",
          dependent: true,
          value: "dailys",
          align: "center",
          role: ["manager", "vendor", "department"],
        },
      ],
      dailyInnerThead: [
        {
          name: "工具箱會議",
          dependent: true,
          value: "toolbox",
          align: "left",
          role: ["manager", "department"],
        },
        {
          name: "是否有施工人員入廠", //實際入廠人員
          dependent: true,
          value: "visitors",
          align: "left",
          role: ["manager", "department"],
        },
        {
          name: "是否有特殊作業",
          dependent: true,
          value: "op",
          align: "left",
          role: ["manager", "department"],
        },
        {
          name: "特殊作業清單",
          dependent: true,
          value: "op_id",
          align: "left",
          role: ["manager", "department"],
        },
        {
          name: "是否影響無塵室潔淨度",
          dependent: true,
          value: "clean",
          align: "left",
          role: ["manager", "department"],
        },
        {
          name: "影響潔淨度原因",
          dependent: true,
          value: "clean_list",
          align: "left",
          role: ["manager", "department"],
        },
        {
          name: "是否影響環境",
          dependent: true,
          value: "environment",
          align: "left",
          role: ["manager", "department"],
        },
        {
          name: "影響環境的原因",
          dependent: true,
          value: "environment_list",
          align: "left",
          role: ["manager", "department"],
        },
        {
          name: "取消特殊作業",
          dependent: true,
          value: "op_cancel",
          align: "left",
          role: ["manager", "department"],
        },
      ],
      table_head_heigh: 50,
      thead_scroll: 0,
      tableData: [],
      innerTableData: [],
      page: {
        size: 7,
        page: 1,
        allPage: null,
      },
      options: {
        contractor: [],
        special: [],
        employee: [],
        employee_key: "name",
        area: [],
        area_key: "location",
        type: [],
        type_key: "name",
        vendor: [],
        vendor_employees: [],
        vendor_employees_key: "name",
        vendor_key: "vendor_chinese",
        op: [],
        op_key: "op_name",
      },
      searchStatus: false,
      uploadFile: [
        {
          name: "工具箱會議及危害告知",
          value: "toolbox",
        },
        {
          name: "承攬商入場切結書",
          value: "affidavit",
        },
      ],
      formData: new FormData(),
      file_list: {},
      month_start: "",
      month_end: "",
      popupStatus: false,
      successText: null,
      popup: null,
      del_data: {},
      vendor_chinese: [],
      op_list: [],
      today: this.$moment(new Date()).format("YYYY-MM-DD"),
      vendor_options: [],
    };
  },
  computed: {
    searchField() {
      return [
        {
          label: "施工開始時間",
          value: "start_date",
          type: "date",
          options: null,
        },
        {
          label: "施工結束時間",
          value: "end_date",
          type: "date",
          options: null,
        },
        {
          label: "表單狀況",
          value: "status",
          type: "select",
          options: [
            {
              label: "所有資料",
              value: "",
            },
            {
              label: "同意",
              value: "同意",
            },
            {
              label: "否決",
              value: "否決",
            },
            {
              label: "作廢",
              value: "作廢",
            },
            {
              label: "簽核中",
              value: "簽核中",
            },
          ],
          options_value: "value",
          options_label: "label",
        },
        // {
        //     label: "工程是否完成",
        //     value: "finish",
        //     type: "radio",
        //     options: [
        //         {
        //             label: "是",
        //             value: "是",
        //         },
        //         {
        //             label: "否",
        //             value: "否",
        //         },
        //     ],
        //     options_value: "value",
        //     options_label: "label",
        // },
        {
          label: "承攬商",
          value: "vendor_id",
          type: "select",
          options: this.vendor_options || [],
          options_value: "value",
          options_label: "label",
        },
      ];
    },
    pageData() {
      // if (this.$route.path.includes('new_construction')) {
      //   const data = [...this.tableData];
      //   //依照施工起始日降冪排序
      //   this.tableSort('start_date_sort');
      //   // this.tableData = data.sort((a, b) => {
      //   //   const dateA = new Date(a.start_date);
      //   //   const dateB = new Date(b.start_date);
      //   //   return dateB - dateA;
      //   // });
      // }
      const list = [];
      for (
        let i = this.page.size * (this.page.page - 1);
        i < this.page.page * this.page.size;
        i++
      ) {
        if (this.tableData[i]) {
          list.push(this.tableData[i]);
        }
      }
      return list;
    },
    //由登入身份決定顯示的欄位
    clearThead() {
      return this.thead.filter((el) => {
        return el.role.includes(this.is_role);
      });
    },
    //由登入身份決定顯示的欄位
    clearInnerThead() {
      return this.innerThead.filter((el) => {
        return el.role.includes(this.is_role);
      });
    },
    finishCase() {
      return function (data) {
        const today = this.$moment();
        const difference = today.diff(data.end_date, "days");
        if (
          difference >= 7 &&
          this.$route.path === "/admin/new_construction_finished"
        ) {
          return "finish_over_7days";
        } else {
          return "finish_case";
        }
      };
    },
    findUpload_files() {
      return function (type_key, data) {
        return data.upload_files.some((file) => file.type === type_key);
      };
    },
  },
  methods: {
    scrollEvent(el) {
      this.thead_scroll = el.target.scrollLeft;
    },
    eventGetHeight(height) {
      this.table_head_heigh = height;
    },
    tableSort(sort_attr) {
      //關閉展開細向
      // 原來的this.inner_status = false;
      // 原來的this.inner_status_index = null;
      //this.check_inner_status = [];
      if (sort_attr.includes("_sort")) {
        //順排
        const attr = sort_attr.split("_sort")[0];
        this.tableData = this.isSort({
          data: this.tableData,
          attr: attr,
          type: "sort",
        });
      } else {
        //逆排
        this.tableData = this.isSort({
          data: this.tableData,
          attr: sort_attr,
          type: "reverse",
        });
      }
    },
    pageChange(value) {
      this.page.page = value;
      //改變頁數先關閉展開係向
      //原來的 this.inner_status = false;
      //原來的 this.inner_status_index = null;
      //this.check_inner_status = [];
    },
    getSpecialOption() {
      this.$http.api.admin.specialOperation().then((res) => {
        this.options.specialList = res.data;
      });
    },
    async getData(search) {
      this.$store.commit("loadingAction", true);;
      if (this.is_role === "department") {
        search = {
          department_id: `${this.$store.state.user.id}`,
        };
      }
      if (this.is_role === "vendor") {
        search = {
          vendor_id: `${this.$store.state.user.id}`,
        };
      }

      //頁面為未結案施工單
      if (this.$route.path.includes("/new_construction_finished")) {
        if (this.is_role === "department") {
          search = {
            close: "否",
            status: "同意",
            department_id: `${this.$store.state.user.id}`,
          };
        } else if (this.is_role === "manager") {
          search = {
            close: "否",
            status: "同意",
          };
        }
        await this.$http.api.vendor.getNewConstruction(search).then((res) => {
          this.searchStatus = false;
          this.tableData = res.data.filter(
            (day) => day.end_date < this.today
          );
          this.page.allPage = this.tableData.length;

          //處理Api回傳的資料為null的值
          const haveValue = ["commit"];
          for (const key of haveValue) {
            for (let i = 0; i < this.tableData.length; i++) {
              const value = this.tableData[i][key];
              if (value == null) {
                if (key == "commit") {
                  this.tableData[i][key] = {};
                } else {
                  this.tableData[i][key] = "";
                }
              } else {
                this.tableData[i][key] = value;
              }
            }
          }
          //處理承攬商及其監工
          for (let i = 0; i < this.tableData.length; i++) {
            this.check_inner_status.push({
              status: false,
              status_index: null,
            });

            const vendors = this.tableData[i].vendors;
            //初始化承包商数组
            this.vendor_chinese[i] = [];
            // // 遍历第一支API中的承包商数据
            for (const vendor of vendors) {
              const vendorId = vendor.vendor_id;
              const new_vendor_chinese = this.options.vendor.find(
                (item) => {
                  return item.vendor_id == vendorId;
                }
              );
              this.vendor_chinese[i].push(
                new_vendor_chinese.vendor_chinese
              );
            }
            // //處理特殊作業(轉換id to 特殊作業名稱)
            const daily_items = this.tableData[i].dailys;
            this.op_list[i] = [];
            for (const daily_item of daily_items) {
              this.op_list[i].push(daily_item);
            }
            this.op_list[i].forEach((op) => {
              if (op.op_id) {
                for (let j = 0; j < op.op_id.length; j++) {
                  const new_op_list = this.options.op.find(
                    (item) => {
                      return item.op_id == op.op_id[j];
                    }
                  );
                  op.op_id[j] = new_op_list.op_name;
                }
              }
            });
          }
          this.tableData.forEach((item, index) => {
            for (let i = 0; i < item.vendors.length; i++) {
              item.vendors[i].vendor_chinese =
                this.vendor_chinese[index][i];
            }
            //處理上傳的 '每日巡檢表' & '危險作業檢查表'
            if (item.dailys.length > 0) {
              item.dailys.forEach((daily, index) => {
                if (daily.upload_files.length > 0) {
                  const daily_item = daily.upload_files.find(
                    (file) => {
                      return file.type == "每日巡檢表";
                    }
                  );
                  daily["daily_check"] = daily_item;
                  const danger_item = daily.upload_files.find(
                    (file) => {
                      return (
                        file.type == "危險作業檢查表"
                      );
                    }
                  );
                  daily["danger_check"] = danger_item;
                }
              });
            }
          });
          this.$store.commit("loadingAction", false);
        });
      } else if (this.$store.state.user.role === "vendor") {
        //search當月起始日
        await this.$http.api.vendor.getNewConstruction(search).then((res) => {
          this.searchStatus = false;
          this.page.allPage = res.data.length;
          this.tableData = res.data;

          //處理Api回傳的資料為null的值
          const haveValue = ["commit"];
          for (const key of haveValue) {
            for (let i = 0; i < this.tableData.length; i++) {
              const value = this.tableData[i][key];
              if (value == null) {
                if (key == "commit") {
                  this.tableData[i][key] = {};
                } else {
                  this.tableData[i][key] = "";
                }
              } else {
                this.tableData[i][key] = value;
              }
            }
          }
          //處理承攬商及其監工
          for (let i = 0; i < this.tableData.length; i++) {
            this.check_inner_status.push({
              status: false,
              status_index: null,
            });

            const vendors = this.tableData[i].vendors;
            console.log("vendors:", vendors);
            //初始化承包商数组
            this.vendor_chinese[i] = [];
            // // 遍历第一支API中的承包商数据
            for (const vendor of vendors) {
              const vendorId = vendor.vendor_id;

              console.log("vendorId:", vendorId);
              //打api得到承攬商資料
            }
            // //處理特殊作業(轉換id to 特殊作業名稱)
            const daily_items = this.tableData[i].dailys;
            this.op_list[i] = [];
            for (const daily_item of daily_items) {
              this.op_list[i].push(daily_item);
            }
            this.op_list[i].forEach((op) => {
              if (op.op_id) {
                for (let j = 0; j < op.op_id.length; j++) {
                  //console.log(item.op_id[j]);
                  const new_op_list = this.options.op.find(
                    (item) => {
                      return item.op_id == op.op_id[j];
                    }
                  );
                  op.op_id[j] = new_op_list.op_name;
                }
              }
            });
          }
          this.tableData.forEach((item, index) => {
            for (let i = 0; i < item.vendors.length; i++) {
              item.vendors[i].vendor_chinese =
                this.vendor_chinese[index][i];
            }
            //處理上傳的 '每日巡檢表' & '危險作業檢查表'
            if (item.dailys.length > 0) {
              item.dailys.forEach((daily, index) => {
                if (daily.upload_files.length > 0) {
                  const daily_item = daily.upload_files.find(
                    (file) => {
                      return file.type == "每日巡檢表";
                    }
                  );
                  daily["daily_check"] = daily_item;
                  const danger_item = daily.upload_files.find(
                    (file) => {
                      return (
                        file.type == "危險作業檢查表"
                      );
                    }
                  );
                  daily["danger_check"] = danger_item;
                }
              });
            }
          });
          this.$store.commit("loadingAction", false);
        });
      } else {
        //search當月起始日
        await this.$http.api.vendor.getNewConstruction(search).then((res) => {
          this.searchStatus = false;
          this.page.allPage = res.data.length;
          this.tableData = res.data;

          //處理Api回傳的資料為null的值
          const haveValue = ["commit"];
          for (const key of haveValue) {
            for (let i = 0; i < this.tableData.length; i++) {
              const value = this.tableData[i][key];
              if (value == null) {
                if (key == "commit") {
                  this.tableData[i][key] = {};
                } else {
                  this.tableData[i][key] = "";
                }
              } else {
                this.tableData[i][key] = value;
              }
            }
          }
          //處理承攬商及其監工
          for (let i = 0; i < this.tableData.length; i++) {
            this.check_inner_status.push({
              status: false,
              status_index: null,
            });

            const vendors = this.tableData[i].vendors;

            //初始化承包商資料
            this.vendor_chinese[i] = [];
            for (const vendor of vendors) {
              const vendorId = vendor.vendor_id;

              const new_vendor_chinese = this.options.vendor.find(
                (item) => {
                  return item.vendor_id == vendorId;
                }
              );
              this.vendor_chinese[i].push(
                new_vendor_chinese.vendor_chinese
              );
            }
            // //處理特殊作業(轉換id to 特殊作業名稱)
            const daily_items = this.tableData[i].dailys;
            this.op_list[i] = [];
            for (const daily_item of daily_items) {
              this.op_list[i].push(daily_item);
            }
            this.op_list[i].forEach((op) => {
              if (op.op_id) {
                for (let j = 0; j < op.op_id.length; j++) {
                  const new_op_list = this.options.op.find(
                    (item) => {
                      return item.op_id == op.op_id[j];
                    }
                  );
                  op.op_id[j] = new_op_list.op_name;
                }
              }
            });
          }
          this.tableData.forEach((item, index) => {
            for (let i = 0; i < item.vendors.length; i++) {
              item.vendors[i].vendor_chinese =
                this.vendor_chinese[index][i];
            }
            //處理上傳的 '每日巡檢表' & '危險作業檢查表'
            if (item.dailys.length > 0) {
              item.dailys.forEach((daily, index) => {
                if (daily.upload_files.length > 0) {
                  const daily_item = daily.upload_files.find(
                    (file) => {
                      return file.type == "每日巡檢表";
                    }
                  );
                  daily["daily_check"] = daily_item;
                  const danger_item = daily.upload_files.find(
                    (file) => {
                      return (
                        file.type == "危險作業檢查表"
                      );
                    }
                  );
                  daily["danger_check"] = danger_item;
                }
              });
            }
          });
          this.$store.commit("loadingAction", false);
        });
      }
    },
    labelTransform({ key, inner_key, data, raw_data }) {
      let item = "";
      if (key === "employee") {
        item = this.options[key].find((el) => {
          for (let el_key in el) {
            if (inner_key.includes(el_key)) {
              return data[key][inner_key[0]] == el[el_key];
            }
          }
        });
      }
      if (item) {
        return item[this.options[`${key}_key`]];
      }
    },
    // labelTransform({ key, inner_key, data, raw_data }) {
    //     console.log(
    //         "key:",
    //         key,
    //         "inner_key:",
    //         inner_key,
    //         "data:",
    //         data,
    //     );
    //     // console.log(this.options[key])
    //     // const item = this.options[key].map((el) => {
    //     //     console.log(el);
    //     //     console.log(data);

    //     //     for (let i = 0; i < data.length; i++) {
    //     //         for (let el_key in el) {
    //     //             //console.log(el_key);
    //     //             if (inner_key.includes(el_key)) {
    //     //                 //console.log(inner_key.includes(el_key));
    //     //                 //console.log(el);
    //     //                 //console.log(el[el_key]);

    //     //             }
    //     //         }
    //     //         return data[i] == el[inner_key];
    //     //     }
    //     // });
    //     console.log(Object.values(data));
    //     const item = Object.values(data).map((el) => {
    //         const option_item = this.options[key]
    //             .map((item) => {
    //                 return item.vendor_chinese == el;
    //             })
    //             .indexOf(true);
    //         console.log(option_item);
    //         return this.options[key][option_item];
    //     });
    //     return el ===this.options[key].vendor_chinese;
    //     console.log(item);
    //     if (item) {
    //         console.log(key);
    //         // return item[this.options[`${key}_key`]];
    //         console.log(item[inner_key]);
    //         return item[inner_key];
    //     }
    // },
    openWork(data, index) {
      //console.log(data, index);
      if (
        this.check_inner_status[index].status_index !== null &&
        this.check_inner_status[index].status_index == index
      ) {
        //代表已經開啟且同一個，要關閉
        //原來的 this.inner_status = false;
        //原來的 this.inner_status_index = null;
        this.check_inner_status[index].status = false;
        this.check_inner_status[index].status_index = null;
      } else {
        //原來的  this.inner_status = true;
        //原來的  this.inner_status_index = index;
        this.check_inner_status[index].status = true;
        this.check_inner_status[index].status_index = index;
      }
    },
    setInnerData(id) {
      return this.innerTableData.filter((el) => {
        return el.application_id == id;
      });
    },
    setTableKey(key) {
      if (key.includes("_")) {
        return key.split("_")[0];
      } else {
        return key;
      }
    },
    openOrder(item) {
      window.open(item.link, "_blank");
    },
    searchAction(search) {
      this.searchStatus = true;
      this.getData(search);
    },
    print(data) {
      //console.log('printData:',data);
      let obj = {
        id: data.id,
        type: "daily",
      };
      this.blankLink("print", obj);
    },
    async updateUOF() {
      //await this.$http.api.admin.updateApplication();
      await this.$http.api.admin.updateNewWork();
      //原來的 this.getData({
      //     start_date: this.month_start,
      //     end_date: this.month_end,
      // });
      this.getData();
    },
    //上傳備註文件
    upload(e, file_type, id) {
      this.$set(this.file_list, file_type, e.target.files[0].name);
      //檔案是複數的
      if (e.target.files.length !== 0) {
        // 將 FileList 轉換為數組
        const fileListArray = Array.from(e.target.files);
        fileListArray.forEach((el) => {
          this.formData.append("attachment[]", el);
        });
      }
      this.$http.api.file
        .new_workUpload(id, this.formData)
        .then(() => {
          //清空
          this.formData = new FormData();
          this.getData();
          this.popupStatus = true;
          this.successText = "上傳成功";
          this.popup = "success";
          e.target.value = ""; //解決 再次上傳同個檔名, 沒有效果的問題
        })
        .catch((error) => {
          this.popupStatus = true;
          this.popup = "error";
          this.successText = "送出失敗";
        });
    },
    //上傳 每日巡檢文件 / 危險作業檢查表
    uploadFinished(e, file_type, id) {
      this.$set(this.file_list, file_type, e.target.files[0].name);
      //檔案是複數的
      if (e.target.files.length !== 0) {
        // 將 FileList 轉換為數組
        const fileListArray = Array.from(e.target.files);
        fileListArray.forEach((el) => {
          this.formData.append("attachment[]", el);
        });
      }
      this.$http.api.file
        .dailysWorkUpload(id, file_type, this.formData)
        .then(() => {
          //清空
          this.formData = new FormData();
          this.getData();
          this.popupStatus = true;
          this.successText = "上傳成功";
          this.popup = "success";
          e.target.value = ""; //解決 再次上傳同個檔名, 沒有效果的問題
        })
        .catch((error) => {
          this.popupStatus = true;
          this.popup = "error";
          this.successText = "送出失敗";
        });
    },
    transfromData(data, th) {
      if (th.includes("[]") && th.includes(".")) {
        const innerKey = th.split("[]");
        const lastKey = innerKey[1].split(".")[1];
        return data[innerKey[0]].map((el) => {
          return el[lastKey];
        });
      } else if (th.includes(".")) {
        const innerKey = th.split(".");
        return data[innerKey[0]][innerKey[1]];
      } else {
        return data[th];
      }
    },
    popupAction() {
      this.$http.api.file
        .deleteFile(this.del_data["data_id"], this.del_data["file_id"])
        .then(() => {
          this.popupStatus = true;
          this.successText = "刪除成功";
          this.popup = "success";
          this.getData();
        })
        .catch((error) => {
          this.popupStatus = true;
          this.popup = "error";
          this.successText = "送出失敗";
        });
    },
    deleteFile(data_id, file_id) {
      console.log(data_id, file_id);
      this.popupStatus = true;
      this.successText = "確定刪除嗎";
      this.popup = "check";
      this.del_data["data_id"] = data_id;
      this.del_data["file_id"] = file_id;
    },
    cancelOP(data) {
      console.log("cancelData:", data.id);
      this.$http.api.file
        .dailyDangerCancel(data.id, true)
        .then(() => {
          this.popupStatus = true;
          this.successText = "更改成功";
          this.popup = "success";
          this.getData();
        })
        .catch((error) => {
          this.popupStatus = true;
          this.popup = "error";
          this.successText = "送出失敗";
        });
    },
    sortDueDate(type, data) {
      //type = asc or desc
      // 假設資料陣列為 this.tableData
      data.sort((a, b) => {
        console.log(a);
        console.log(b);
        // 根據 type 決定是升序還是降序
        if (type === "asc") {
          // 升序
          return new Date(a.end_date) - new Date(b.end_date);
        } else if (type === "desc") {
          // 降序
          return new Date(b.end_date) - new Date(a.end_date);
        }
        // 預設升序
        return new Date(a.end_date) - new Date(b.end_date);
      });
    },

    poupupEnter() {
      this.popupStatus = false;
    },
  },

  async created() {
    this.$store.commit("loadingAction", null);
    this.month_start = this.$moment().startOf("month").format("YYYY-MM-DD");
    this.month_end = this.$moment().endOf("month").format("YYYY-MM-DD");
    if (this.is_role !== "vendor") {
      this.options.vendor = await Options.getVendor();
      this.vendor_options = this.options.vendor.map((vendor) => {
        return {
          label: vendor.vendor_chinese,
          value: vendor.vendor_id,
        };
      });
      this.options.employee = await Options.getDepartmentEmployee();
    }
    this.options.area = await Options.getArea();
    this.options.vendor_employees = await Options.getVenderEmployee();
    this.options.type = await Options.constructionType();
    this.options.op = await Options.getSpecialOperation();
    if (this.$route.path === "/admin/new_construction_finished") {
      if (this.$store.state.user.role === "manager") {
        await this.getData();
      } else {
        await this.getData();
      }
    } else {
      await this.getData({
        //start_date: this.month_start,
        // end_date: this.month_end,
      });
    }
    if (this.$route.path.includes('new_construction')) {

      //依照施工起始日降冪排序
      this.tableSort('start_date');
      const data = [...this.tableData];
      // this.tableData = data.sort((a, b) => {
      //   const dateA = new Date(a.start_date);
      //   const dateB = new Date(b.start_date);
      //   return dateB - dateA;
      // });
    }
  },
  watch: {
    tableData: {
      immediate: true,
      handler(newVal) {
        if (
          this.$route.path === "/admin/new_construction_finished" &&
          newVal
        ) {
          this.sortDueDate("desc");
        }
      },
    },
  },
};
</script>
